import Span from '@inspire/ui/chakra/Span';

const ConsigneTag = () => (
  <Span bg="yellow.300" color="yellow.900" px={1} borderRadius={2}>
    Consigne
  </Span>
);

export default ConsigneTag;
